import { render, staticRenderFns } from "./header_tel.vue?vue&type=template&id=b34bca12&scoped=true&"
import script from "./header_tel.vue?vue&type=script&lang=js&"
export * from "./header_tel.vue?vue&type=script&lang=js&"
import style0 from "./header_tel.vue?vue&type=style&index=0&id=b34bca12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34bca12",
  null
  
)

export default component.exports